// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/

export const get_img_url = (img_name: string)=>{
    return `https://hola.org/static/${img_name}`;
};
